<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Contact Information
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">
            First Name
          </div>
          <SACInput
            field="firstName"
            placeholder="Enter First Name"
            :value="newCustomerInfo.firstName"
            :error="errorObj.firstNameErr"
            :change="(field, value) => changeCustomerDetailInfo(field, value)"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Last Name
          </div>
          <SACInput
            field="lastName"
            placeholder="Enter Last Name"
            :value="newCustomerInfo.lastName"
            :error="errorObj.lastNameErr"
            :change="(field, value) => changeCustomerDetailInfo(field, value)"
          />
        </div>
      </div>
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="ac-input-header">
            Email
          </div>
          <SACInput
            field="email"
            placeholder="Enter Email"
            :value="newCustomerInfo.email"
            :error="errorObj.emailErr"
            :change="(field, value) => changeCustomerDetailInfo(field, value)"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Phone
          </div>
          <SACInput
            field="phone"
            placeholder="Enter Phone Number"
            :value="newCustomerInfo.phone"
            :error="errorObj.phoneErr"
            :change="(field, value) => changeCustomerDetailInfo(field, value)"
          />
        </div>
      </div>
      <div class="ac-input-container" v-if="isSmacAdmin">
        <div class="ac-input-header">
          Hubspot Id
        </div>
        <SACInput
          field="hubspotId"
          type="number"
          placeholder="Enter Hubspot Id"
          :value="newCustomerInfo.hubspotId"
          :error="errorObj.hubspotIdErr"
          :change="(field, value) => changeCustomerDetailInfo(field, value)"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="updateContactInfo"
      >
        Update
      </button>
    </div>
    <ProcessOverlay
      :show="infoEditing"
      text="Updating Contact Information"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ContactInfoForm',
  components: {
    SACInput,
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
};
</script>
